'use strict'

import fr from './fr'
import en from './en'
import zh from './zh'

export default {fr, en, zh}



// WEBPACK FOOTER //
// ./src/i18n/index.js